export default __webpack_public_path__ + "static/media/Prancheta 5.5b81ce75.svg";